import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Spin,
} from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { BsBack } from "react-icons/bs";
import { IoReturnDownBackSharp } from "react-icons/io5";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import FormHeading from "../../../Components/FormComponents/FormHeading";
import { LoadingOutlined } from "@ant-design/icons";

import {
  Date2,
  Date4,
  Radio2,
  Select2,
  Select4,
  Text2,
  Text4,
} from "../../../Components/FormComponents/InputFields";
import SubmitButton from "../../../Components/FormComponents/SubmitButton";
import { GetSingleEmployeeData } from "../../../Services/CommonApis";
import {
  ApiKycSubmit,
  GetOtpAPI,
  UpdateEmployeeApi,
  VerifyOtpAPI,
  VerifyPanAPI,
} from "../../../Services/EmployeeManager";
import UploadImage from "./UploadImage";
import { MdArrowBack, MdBackHand } from "react-icons/md";
const { Option } = Select;
export default function EmployeeAllDetails({ pageType }) {
  const { dropDowns } = useOutletContext();
  console.log(pageType);

  const [api, contextHolder] = notification.useNotification();

  const [initialData, setInitialData] = useState(null);
  const [toggleDisable, setToggleDisable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [getdata, setGetdata] = useState(false);
  const [aadhaarRes, setAadhaarRes] = useState();
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [aadhaarStatus, setAadhaarStatus] = useState("ok");
  const [aadhaarReason, setAadhaarReason] = useState("");
  const [submitLoader, setSubmitLoader] = useState(false);

  const [panStatus, setPanStatus] = useState("ok");
  const [panReason, setPanReason] = useState("");
  const [aadharData, setAadharData] = useState({
    aadhar_num: "",
    mobile: "",
    _id: "",
  });
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("get_otp");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { id } = useParams();

  const navigate = useNavigate();

  const { control, errors, handleSubmit, reset, setValue, getValues } =
    useForm();

  const getEmployeeData = async () => {
    try {
      const { data } = await GetSingleEmployeeData(id);
      console.log(data);
      setEmployeeData(data.data);
      setGetdata(data?.data);
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to Check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const setEmployeeData = (val) => {
    setValue("title", val?.title);
    setValue("gender", val?.gender);

    setValue("firstName", val?.name?.first_name);
    setValue("middleName", val?.name?.middle_name);

    setValue("lastName", val?.name?.last_name);
    setValue("dob", val?.birth?.dob?.split(" ")[0]);

    setValue("mobile", val?.mobile ? val?.mobile : null);
    setValue(
      "emergencyContact",
      val?.emergency_contact ? val?.emergency_contact : null
    );

    setValue("bloodGroup", val?.blood_group ? val?.blood_group : null);
    setValue("personalEmail", val?.email?.personal);

    setValue("aadharNumber", val?.id_cards?.aadhar_number);
    setValue("panNumber", val?.id_cards?.pan_number);

    setValue("employeeId", val?.employee_id);
    setValue("companyEmail", val?.email?.company);

    setValue("doj", val?.date_of_joining?.split(" ")[0]);
    setValue("company", val?.company);

    setValue("businessUnit", val?.business_unit);
    setValue("function", val?.function);

    setValue("corporate", val?.location?.corporate);
    setValue("office", val?.location?.office);

    setValue("designation", val?.designation);
    setValue("role", val?.job_role);

    setValue("managerId", val?.reporting_manager?.employee_id);
    setValue("isActive", val?.is_active);
    setValue("interviewDate", val?.interview?.date?.split(" ")[0]);
    setValue("interviewer", val?.interview?.interviewer);

    setInitialData(val);

    setToggleDisable(false);
  };

  const onSubmit = async (val) => {
    try {
      setLoader(true);
      const data = await UpdateEmployeeApi(id, val);
      setLoader(false);

      if (data.data.success) {
        api.success({
          message: data.data.message,
          placement: "top",
        });
        if (pageType === "employees-verification") {
          if (getdata?.pan_verified !== true) {
            await handleVerifypan();
          }

          if (getdata?.aadhar_verified !== true) {
            setIsModalVisible(true);
            setAadharData({
              aadhar_num: val.aadharNumber,
              mobile: val.mobile || "",
              _id: getdata?._id,
            });
          }
          if (getdata?.pan_verified && getdata?.aadhar_verified) {
            if (getdata?.overall_status === "INITIATED") {
              navigate("/admin/employees-verification");
            } else {
              // setIsModalVisible2(true);
              getEmployeeData();
            }
          }
        } else {
          navigate("/admin/employees-manager");
        }
      } else {
        api.error({
          message: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        placement: "top",
      });
    }
  };

  const handleVerifypan = async () => {
    try {
      const pan = getValues("panNumber");
      const response = await VerifyPanAPI(pan, getdata?._id);
      if (!response?.data?.success) {
        console.log(response);

        api.error({ message: response?.data?.message, placement: "top" });
      } else {
        getEmployeeData();
      }
    } catch (error) {
      console.error("PAN verification failed:", error);
    }
  };

  const handleGetOtp = async () => {
    setSubmitLoader(true);

    try {
      const response = await GetOtpAPI(aadharData);
      if (response?.data?.success) {
        setSubmitLoader(false);

        setAadhaarRes(response?.data?.message);

        setStep("verify_otp");
        api.success({ message: "OTP sent successfully", placement: "top" });
      } else {
        api.error({ message: response?.data?.message, placement: "top" });
      }
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);

      api.error({ message: "Failed to send OTP", placement: "top" });
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setSubmitLoader(true);

      const response = await VerifyOtpAPI(aadhaarRes, aadharData, otp);
      if (response?.data?.success) {
        setSubmitLoader(false);

        api.success({
          message: "Aadhar verified successfully",
          placement: "top",
        });
        setIsModalVisible(false);
        setOtp("");
        setStep("get_otp");
        setIsModalVisible2(true);
        getEmployeeData();
      } else {
        api.error({ message: response?.data?.message, placement: "top" });

        navigate("/admin/employees-verification");
      }
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);

      api.error({ message: "OTP verification failed", placement: "top" });
    }
  };

  const handleKycSubmit = async () => {
    try {
      const payload = {
        _id: aadharData._id,
        aadhar_verified: aadhaarStatus === "ok",
        pan_verified: panStatus === "ok",
        ...(aadhaarStatus === "deviation" && {
          aadhar_deviation: aadhaarReason,
        }),
        ...(panStatus === "deviation" && { pan_deviation: panReason }),
      };

      const res = await ApiKycSubmit(payload);

      if (res?.data?.success) {
        api.success({ message: `KYC Submitted`, placement: "top" });
        setIsModalVisible2(false);
        navigate("/admin/employees-verification");
      } else {
        api.error({ message: res?.data?.message, placement: "top" });
      }
    } catch (err) {
      console.log(err);
      // api.error({ message: "KYC verification failed", placement: "top" });
    }
  };
  useEffect(() => {
    getEmployeeData();
  }, []);

  return (
    <>
      {contextHolder}
      <Col className="bg-white round-edges px-3">
        <Button className="my-3" onClick={() => navigate(-1)}>
          <MdArrowBack className="mr-1 fs-5" />
        </Button>
        <Row
          className="align-content-start py-3"
          style={{
            height: "calc(100% - 76px)",
            overflow: "auto",
            boxShadow:
              "rgb(0 0 0 / 10%) 0px 1px 0px 0px, rgb(0 0 0 / 10%) 0px -1px 0px 0px",
          }}
        >
          <Col className={`px-3 my-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Personal Details
            </h2>
          </Col>

          {/* <div className="upload-img">
            <UploadImage
              getEmployeeData={getEmployeeData}
              photoUrl={initialData?.photo_url && initialData?.photo_url}
              empId={initialData?.employee_id}
            ></UploadImage>
          </div> */}
          <Select4
            control={control}
            errors={errors}
            id="gender"
            name="Gender"
            options={dropDowns && dropDowns.GENDER}
          />

          <Select4
            control={control}
            errors={errors}
            id="title"
            name="Title"
            options={dropDowns && dropDowns.TITLE}
          />

          <Text4
            control={control}
            errors={errors}
            id="firstName"
            name="First Name"
            validations={{ required: true }}
          />
          <Text4
            control={control}
            errors={errors}
            id="middleName"
            name="Middle Name"
          />

          <Text4
            control={control}
            errors={errors}
            id="lastName"
            name="Last Name"
            validations={{ required: true }}
          />
          <Date4
            control={control}
            errors={errors}
            id="dob"
            name="Date of Birth"
            validations={{ required: true }}
          />

          <Text4
            control={control}
            errors={errors}
            id="mobile"
            name="Mobile"
            type="tel"
            maxLength={10}
          />
          <Text4
            control={control}
            errors={errors}
            id="emergencyContact"
            name="Emergency Contact"
            type="tel"
            maxLength={10}
          />
          <Select4
            control={control}
            errors={errors}
            id="bloodGroup"
            name="Blood Group"
            options={dropDowns && dropDowns.BLOOD_GROUP}
          />
          <Text4
            control={control}
            errors={errors}
            id="personalEmail"
            name="Personal Email"
            disabled={true}
            validations={{ required: true }}
          />

          <Text4
            control={control}
            errors={errors}
            id="aadharNumber"
            name="Aadhar Card Number"
            type="tel"
            maxLength={12}
            disabled={getdata?.aadhar_verified}
          />

          <Text4
            control={control}
            errors={errors}
            id="panNumber"
            name="Pan Card Number"
            maxLength={10}
            disabled={getdata?.pan_verified}
          />

          <Divider />

          <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Professional Details
            </h2>
          </Col>
          <Text4
            control={control}
            errors={errors}
            id="employeeId"
            name="Employee ID"
            // disabled={true}
            validations={{ required: false }}
          />
          <Text4
            control={control}
            errors={errors}
            id="companyEmail"
            name="Company Email"
            disabled={true}
          />

          <Date4
            control={control}
            errors={errors}
            id="doj"
            name="Date of Joining"
            validations={{ required: false }}
          />
          <Select4
            control={control}
            errors={errors}
            id="company"
            name="Company"
            options={dropDowns && dropDowns.COMPANY}
          />

          <Select4
            control={control}
            errors={errors}
            id="businessUnit"
            name="Business Unit"
            options={dropDowns && dropDowns.BUSINESS_UNIT}
          />
          <Select4
            control={control}
            errors={errors}
            id="function"
            name="Function"
            options={dropDowns && dropDowns.FUNCTION}
          />

          <Select4
            control={control}
            errors={errors}
            id="corporate"
            name="Corporate"
            options={dropDowns && dropDowns.CORPORATE}
          />
          {/* <Text4 control={control} errors={errors}  id='corporate' name='Corporate'/> */}
          <Select4
            control={control}
            errors={errors}
            id="office"
            name="Office"
            options={dropDowns && dropDowns.OFFICE}
          />

          <Text4
            control={control}
            errors={errors}
            id="designation"
            name="Designation"
          />
          <Select4
            control={control}
            errors={errors}
            id="role"
            name="Role"
            options={dropDowns && dropDowns.ROLE}
          />

          <Text4
            control={control}
            errors={errors}
            id="managerId"
            name="Reporting Manager ID"
          />

          <Date4
            control={control}
            errors={errors}
            id="interviewDate"
            name="Interview Date"
            validations={{ required: false }}
          />

          <Text4
            control={control}
            errors={errors}
            id="interviewer"
            name="Interviewer Name"
          />
          <Radio2
            control={control}
            errors={errors}
            id="isActive"
            name="Is Active"
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
          />
        </Row>

        <Button
          size="large"
          onClick={handleSubmit(onSubmit)}
          type="primary"
          className="mt-4 mb-4 bg-[#76CAF8] flex  justify-end"
          disabled={loader}
        >
          {loader && (
            <Spin
              className="mr-2 mb-2"
              size="default"
              indicator={<LoadingOutlined className="text-light" />}
              spinning={true}
            />
          )}
          Update
        </Button>
      </Col>
      <Modal
        title="Verify Aadhar"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setStep("get_otp");
          setOtp("");
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        {step === "get_otp" ? (
          <Form layout="vertical" onFinish={handleGetOtp}>
            <Form.Item label="Aadhar Number">
              <Input value={aadharData?.aadhar_num} disabled />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobile"
              initialValue={aadharData.mobile}
            >
              <Input
                onChange={(e) =>
                  setAadharData({ ...aadharData, mobile: e.target.value })
                }
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" disabled={submitLoader}>
              {submitLoader && (
                <Spin
                  className="mr-2 mb-2"
                  size="default"
                  indicator={<LoadingOutlined className="text-light" />}
                  spinning={true}
                />
              )}
              Get OTP
            </Button>
          </Form>
        ) : (
          <Form layout="vertical" onFinish={handleVerifyOtp}>
            <Form.Item label="OTP">
              <Input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" disabled={submitLoader}>
              {submitLoader && (
                <Spin
                  className="mr-2 mb-2"
                  size="default"
                  indicator={<LoadingOutlined className="text-light" />}
                  spinning={true}
                />
              )}
              Verify OTP
            </Button>
          </Form>
        )}
      </Modal>
      <Modal
        title="KYC Verification Summary"
        open={isModalVisible2}
        onCancel={() => setIsModalVisible2(false)}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        {getdata ? (
          <div className="space-y-6">
            {/* User Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">User Details</h3>
              <p>
                <strong>Name:</strong> {getdata?.name?.full_name}
              </p>
              <p>
                <strong>Mobile:</strong> {getdata?.mobile}
              </p>
            </div>

            {/* Aadhaar Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">Aadhaar Details</h3>
              <p>
                <strong>Aadhaar Number:</strong>{" "}
                {getdata?.aadhar_response_data?.aadhar_number}
              </p>
              <p>
                <strong>Full Name:</strong>{" "}
                {getdata?.aadhar_response_data?.full_name}
              </p>
              <p>
                <strong>Linked Mobile:</strong> {getdata?.mobile}
              </p>

              <div className="mt-3 space-y-2">
                <Select
                  value={aadhaarStatus}
                  onChange={setAadhaarStatus}
                  className="w-full"
                >
                  <Option value="ok">OK</Option>
                  <Option value="deviation">Deviation</Option>
                </Select>
                {aadhaarStatus === "deviation" && (
                  <Input.TextArea
                    placeholder="Enter Aadhaar deviation reason"
                    value={aadhaarReason}
                    onChange={(e) => setAadhaarReason(e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* PAN Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">PAN Details</h3>
              <p>
                <strong>PAN Number:</strong>{" "}
                {getdata?.pan_response_data?.data?.pan_number}
              </p>
              <p>
                <strong>Name on PAN:</strong>{" "}
                {getdata?.pan_response_data?.data?.full_name}
              </p>

              <div className="mt-3 space-y-2">
                <Select
                  value={panStatus}
                  onChange={setPanStatus}
                  className="w-full"
                >
                  <Option value="ok">OK</Option>
                  <Option value="deviation">Deviation</Option>
                </Select>
                {panStatus === "deviation" && (
                  <Input.TextArea
                    placeholder="Enter PAN deviation reason"
                    value={panReason}
                    onChange={(e) => setPanReason(e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* Final Submit Button */}
            <div className="text-right">
              <Button
                type="primary"
                onClick={handleKycSubmit}
                disabled={
                  (aadhaarStatus === "deviation" && !aadhaarReason.trim()) ||
                  (panStatus === "deviation" && !panReason.trim())
                }
              >
                Submit KYC
              </Button>
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </>
  );
}
